import { round } from "@/utils/math";

export function formatVentUnits(units?: string) {
  // RKP doesn't send over subscript, so swith the units to subscript
  if (units) units = units.replace("H2O", "H₂O");

  return units;
}

export function formatVentNumber(value?: number, decimals?: number) {
  if (!value && value !== 0) return "–";

  if (!decimals) decimals = 2;
  return round(value, decimals);
}

export function formatVentBoolean(value?: boolean, yes?: string, no?: string) {
  if (!value && value !== false) return "–";

  if (!yes) yes = "Yes";
  if (!no) no = "No";

  return value ? yes : no;
}

export function formatVentText(value?: string) {
  if (!value && value !== "") return "–";

  return value;
}

export function formatVentValue(value?: any) {
  if ((!value && value !== 0) || isNaN(value)) return formatVentText(value);

  return formatVentNumber(value);
}

export function formatVentFiO2Monitoring(value?: string) {
  if (!value) return "–";

  if (value.match(/enabled/i)) return "Enabled";
  else if (value.match(/disabled/i)) return "Disabled";
  else return value;
}
